// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".symbol-tips[data-v-55494b6b] {\n  margin-left: 75px;\n  margin-top: -6px;\n  margin-bottom: 21px;\n}\n.symbol[data-v-55494b6b] {\n  width: 100px;\n  line-height: 31px;\n  text-align: center;\n}\n.lang[data-v-55494b6b] {\n  width: 100%;\n}\n.lang[data-v-55494b6b] .el-form-item__content {\n  width: 79%;\n}", ""]);
// Exports
module.exports = exports;
